import React, { PropsWithChildren } from "react";
import { Form } from "semantic-ui-react";
import { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import { WidgetProps } from "@rjsf/core";
import { ImageInput, IFileUploadElementProps } from "../../../../../sg-fileupload";
import { useSchemaTranslation } from "../../../../hooks/useSchemaTranslation";
import { InputElement } from "../../components/InputElement";

const getTextProps = (t: TFunction) => ({
  downloadImageByDraggingOrClickHere: t("Lataa kuva raahaamalla se tähän tai napsauttamalla"),
});

const InputAreaElement: React.FC<PropsWithChildren<IFileUploadElementProps>> = (props) => {
  const texts = getTextProps(useTranslation().t);
  return (
    <InputElement
      {...props}
      text={texts.downloadImageByDraggingOrClickHere}
      icon="camera"
    />
  );
};



function ImageUploadWidget({
  disabled,
  value,
  onChange,
  readonly,
  label,
  required,
}: WidgetProps) {

  const { t } = useSchemaTranslation();

  const onAddImage = (newImages: { id: string; name: string }[]) => {
    if (onChange) {
      onChange((value || []).concat(newImages));
    }
  };

  const onRemovedImage = (guid: string) => {
    if (onChange) {
      onChange(value.filter((file: any) => file.id !== guid));
    };
  };
  return (
    <Form.Field required={required} disabled={readonly || disabled}>
      {label && <label> {t(label)} </label>}
      <ImageInput
        multiple
        inputAreaElem={InputAreaElement}
        onUploaded={onAddImage}
        onRemoved={onRemovedImage}
        files={value || []}
        disabled={disabled || readonly}
      />
    </Form.Field>
  );
}

export default ImageUploadWidget;
